function toRemainDaysNumber(value) {
    if (value == null || value === "") {
        return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}

function calcRemainDaysFromDate(usePeriodDate) {
    if (!usePeriodDate) {
        return null;
    }

    const end = new Date(usePeriodDate);
    if (Number.isNaN(end.getTime())) {
        return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const diffMs = end.getTime() - today.getTime();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

function resolveRemainDays(user) {
    const fromApi = toRemainDaysNumber(user?.remainDays);
    if (fromApi != null) {
        return fromApi;
    }

    const hasUsePeriodDate = user?.usePeriodDate != null && user.usePeriodDate !== "";
    if (!hasUsePeriodDate) {
        return null;
    }

    return calcRemainDaysFromDate(user.usePeriodDate);
}

/**
 * @returns {{ text: string, tone: 'remaining' | 'expired' | 'unlimited' } | null}
 */
export function getUserRemainPeriodDisplay(user) {
    const remainDays = resolveRemainDays(user);

    if (remainDays == null) {
        return {text: "무기한", tone: "unlimited"};
    }

    if (remainDays < 0) {
        return {text: "만료", tone: "expired"};
    }

    return {text: `+ ${remainDays} 일`, tone: "remaining"};
}
